<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Customer Management">
    <ng-template matTabContent
      ><app-customer-mngt></app-customer-mngt>
    </ng-template>
  </mat-tab>
  <mat-tab label="Machine Management">
    <ng-template matTabContent
      ><app-machine-mngt
        (machinesAddedOrUpdated)="onMachinesAddedOrUpdated()"
      ></app-machine-mngt>
    </ng-template>
  </mat-tab>
  <mat-tab label="Agent Management">
    <ng-template matTabContent><app-agent-mngt></app-agent-mngt> </ng-template>
  </mat-tab>
  <mat-tab label="User Management">
    <ng-template matTabContent><app-user-mngt></app-user-mngt> </ng-template>
  </mat-tab>
  <mat-tab label=" Software Info">
    <ng-template matTabContent><app-version-info></app-version-info> </ng-template>
  </mat-tab>
</mat-tab-group>
